







import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapMutations } from 'vuex'
import GameLaunch from '@/game'

@Component({
  components: {},
  methods: mapMutations([])
})
export default class Game extends Vue {
  downloaded: boolean = false

  mounted() {
    Promise.resolve().then(() => {
      this.downloaded = true
      this.$nextTick(() => this.$store.dispatch('setGame', GameLaunch.launch()))
    })
  }
}
